import React from 'react';
import {
  shape,
  string,
  bool,
  func,
} from 'prop-types';

const EmailTextBox = (props) => {
  const {
    input,
    isUniqueEmail,
    showSignIn,
    dataTestId,
    prefillLoginEmail,
    signIn,
    label,
    type,
    meta: { touched, error },
    readOnly,
  } = props;

  const transitionViaEmail = (e) => {
    e.preventDefault();
    prefillLoginEmail(input.value);
    signIn();
  };

  const hidden = type === 'hidden';
  const hasError = (touched || hidden) && error;
  const inputStyle = {};
  if (hidden) {
    inputStyle.border = 0;
    inputStyle.height = 'auto';
    if (!hasError) {
      inputStyle.margin = 'auto';
    }
  }

  return (
    <div className={`gcc-input ${hasError ? 'has-error' : ''}`} id="email-field" style={inputStyle}>
      <input
        {...input}
        id={input.name}
        data-test-id={dataTestId}
        type={type}
        className={`ba b--black-20 bw1 br3 pa2 pl2 ${input.value ? 'filled' : ''}  ${readOnly ? 'read-only-gray' : ''}`}
        readOnly={readOnly}
      />
      {label && <label htmlFor={input.name} className="f5 pa2 pl2">{label}</label>}
      {hasError &&
        <div className="gcc-input-help">
          {isUniqueEmail ?
            <span className="error">{error}</span>
            :
            <span className="error">
              Email already registered. {showSignIn && <a href="#signIn" onClick={e => transitionViaEmail(e)}>Want to sign in?</a>}
            </span>
          }
        </div>
      }
    </div>
  );
};


EmailTextBox.defaultProps = {
  dataTestId: '',
  isUniqueEmail: true,
  showSignIn: true,
  readOnly: false,
};

EmailTextBox.propTypes = {
  input: shape({}).isRequired,
  dataTestId: string,
  isUniqueEmail: bool,
  showSignIn: bool,
  prefillLoginEmail: func.isRequired,
  label: string.isRequired,
  signIn: func.isRequired,
  type: string.isRequired,
  meta: shape({}).isRequired,
  readOnly: bool,
};

export default EmailTextBox;
